import { useQuery, useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../../js/api/axios";
import { queryClient } from "../queryClient";

export const fetchAddSavedColorsToCollection = async (url) => {
  const response = await axiosInstance.get(url);
  return response.data;
};

export const saveColor = async (url) => {
  const response = await axiosInstance.post(url);
  return response.data;
};

export const deleteColor = async (url) => {
  const response = await axiosInstance.post(url);
  return response.data;
};

export const useAddSavedColorsToCollection = (url) => {
  return useQuery({
    queryKey: ["add-saved-colors-to-collection-content"],
    queryFn: async () => await fetchAddSavedColorsToCollection(url),
  });
};

export const useCmsSaveColor = () => {
  return useMutation({
    mutationFn: async ({ url }) => {
      await saveColor(url);
    },
    onSuccess: (_, { successHandler }) => {
      queryClient.invalidateQueries("my-saved-colors-dialog").then((data) => {
        if (successHandler) {
          successHandler(data);
        }
      });
    },
    onError: (_, { errorHandler }) => {
      if (errorHandler) {
        errorHandler();
      }
    },
  });
};

export const useCmsDeleteColor = () => {
  return useMutation({
    mutationFn: async ({ url }) => {
      await deleteColor(url);
    },
    onSuccess: (_, { successHandler }) => {
      queryClient.invalidateQueries("my-saved-colors-dialog").then((data) => {
        if (successHandler) {
          successHandler(data);
        }
      });
    },
    onError: (_, { errorHandler }) => {
      if (errorHandler) {
        errorHandler();
      }
    },
  });
};

export const updateColorCollectionFromSavedColors = async ({ url, body }) => {
  const response = await axiosInstance.post(url, body);
  return response.data;
};

export const useEditColorCollectionFromSavedColors = () => {
  return useMutation({
    mutationFn: async ({ url, body }) => {
      return await updateColorCollectionFromSavedColors({ url, body });
    },
    onSuccess: (responseData, { successHandler }) => {
      if (successHandler) {
        successHandler(responseData);
      }
    },
    onError: (data, { errorHandler }) => {
      if (errorHandler) {
        errorHandler(data);
      }
    },
  });
};
